export interface IClass {
    id: string;
    name: string;
    className: string;
    studentsCount: number;
    schoolYear: string;
}

export class Class implements IClass {
    readonly id: string;
    readonly name: string;
    readonly className: string;
    readonly studentsCount: number;
    readonly schoolYear: string;
    readonly displayName: string;

    constructor(cl: IClass) {
        this.id = cl.id;
        this.name = cl.name;
        this.className = cl.className;
        this.studentsCount = cl.studentsCount;
        this.schoolYear = cl.schoolYear;
        this.displayName = this.className + (cl.schoolYear.trim() ? ` (${cl.schoolYear})` : '');
    }
}
